export const BlockFeedbackStrings = {
  q1: {
    question: '1.	How well do you think you did in this section:',
    answers: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent'],
  },
  q2: {
    question: '2.	The task in THIS block was:',
    answers: ['Easy', 'Moderate or Medium', 'Challenging', 'Hard', 'Very Hard'],
  },
  q3: {
    question:
      '3.	The Imagery Task for THIS block was the same as the first block you completed at the beginning of the experiment.',
    cont: 'My strategy for THIS block compared to the first block:',
    answers: [
      'Did Not Change',
      'Changed A Little',
      'Changed Somewhat',
      'Changed A Lot',
      'Changed Completely',
    ],
  },
  q4: {
    question:
      '3.	The Memory Task for THIS block was the same as the first block you completed at the beginning of the experiment.',
    cont: 'My strategy for THIS block compared to the first block:',
    answers: [
      'Did Not Change',
      'Changed A Little',
      'Changed Somewhat',
      'Changed A Lot',
      'Changed Completely',
    ],
  },
}
